// src/utils/alert.js
import Swal from "sweetalert2";

// ✅ Show a toast notification
export const showToast = (icon, title) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon, // "success" | "error" | "warning" | "info"
    title,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });
};

// ✅ Show a simple confirmation modal (returns true/false)
export const showConfirm = async (title, text) => {
  const result = await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, confirm it!",
  });
  return result.isConfirmed;
};

// ✅ Show confirmation modal and run an async action while showing loader
// onConfirm should be an async function
export const showConfirmAsync = async (title, text, onConfirm) => {
  const result = await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, confirm it!",
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async () => {
      try {
        const r = await onConfirm();
        return r;
      } catch (err) {
        const message = (err && err.message) || err || "Request failed";
        Swal.showValidationMessage(String(message));
        throw err; // ensures modal stays open and shows validation
      }
    },
  });

  return result;
};
